import { render, staticRenderFns } from "./SensorEdit.vue?vue&type=template&id=8a4060ca&scoped=true"
import script from "./SensorEdit.vue?vue&type=script&lang=js"
export * from "./SensorEdit.vue?vue&type=script&lang=js"
import style0 from "./SensorEdit.vue?vue&type=style&index=0&id=8a4060ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4060ca",
  null
  
)

export default component.exports